import { render, staticRenderFns } from "./DocumentEditDialog.vue?vue&type=template&id=45accc3a"
import script from "./DocumentEditDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports